import { useLanguage } from 'context/AppContext';
import { DeliveryChip } from './DeliveryChip';
import theme from 'App.theme';

type Props = {
  express?: boolean;
  turnaroundOrigin?: boolean;
  turnaroundDestination?: boolean;
  selectedRateName?: string;
};

const DeliveryPriorityLabels = ({ express, turnaroundOrigin, turnaroundDestination, selectedRateName = '' }: Props) => {
  const lang = useLanguage()[0].DeliveryListPage.table;

  const selectedRateLabel =
    selectedRateName.match(/\bPOT\b/) || selectedRateName.match(/\bNext\s*Flight\b/i) ? lang.urgent : '';

  return express || turnaroundOrigin || turnaroundDestination || selectedRateLabel ? (
    <span
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.layout.spacing.small,
      }}
    >
      {!!selectedRateLabel && <DeliveryChip variant="selectedRate">{selectedRateLabel}</DeliveryChip>}
      {express && <DeliveryChip variant="express">{lang.express}</DeliveryChip>}
      {turnaroundOrigin && <DeliveryChip variant="turnaroundOrigin">{lang.turnaround}</DeliveryChip>}
      {turnaroundDestination && <DeliveryChip variant="turnaroundDestination">{lang.turnaround}</DeliveryChip>}
    </span>
  ) : null;
};

export default DeliveryPriorityLabels;
